module.exports = __webpack_public_path__ + "638779efa41a0320f06e8c38343a44c7.svg";